module.exports = __webpack_public_path__ + "img/Korkein-Ykkösluokan-Mestari.12983369.png";